import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { SummaryComponent } from './summary.component';

@NgModule({
  declarations: [SummaryComponent],
  imports: [CommonModule, LinkModule],
  exports: [SummaryComponent]
})
export class SummaryModule {}
